// extracted by mini-css-extract-plugin
module.exports = {"emptyDetail":"styles_emptyDetail__3rYKE","selectToStartArrow":"styles_selectToStartArrow__yfJss"};